import { siteStats } from "@/mocks/events";
import Reveal from "@/components/base/Reveal";

export default function StatsStrip() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4">
          {siteStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 70}>
              <div className="flex items-start gap-4 px-4 md:px-6 lg:border-l border-background-300 first:border-l-0">
                <span className="w-11 h-11 shrink-0 rounded-lg bg-background-50 border border-background-200 text-primary-600 flex items-center justify-center">
                  <i
                    className={
                      index === 0
                        ? "ri-radar-line text-xl"
                        : index === 1
                          ? "ri-add-circle-line text-xl"
                          : index === 2
                            ? "ri-timer-flash-line text-xl"
                            : "ri-stack-line text-xl"
                    }
                  />
                </span>
                <div>
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                      {stat.value}
                    </span>
                    <span className="text-sm text-foreground-500">{stat.unit}</span>
                  </div>
                  <p className="mt-1 text-sm font-label text-foreground-800">{stat.label}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{stat.note}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}